import { DesignLanguage, MoneyConfig, MoneyHook, useMoney as useCoreMoney, useIsDesignLanguage } from '@afterpaytouch/core'
import { useCrossBorderTrade, useIsConsumerLendingOrder } from '../../state'

export const useMoney = (params: MoneyConfig): MoneyHook => {
  const { isCrossBorder } = useCrossBorderTrade()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const isConsumerLendingOrder = useIsConsumerLendingOrder()

  const currencyDisplay = isCrossBorder && isArcadeDesignLanguage && !isConsumerLendingOrder ? 'code' : 'symbol'
  return useCoreMoney({ ...params, currencyDisplay })
}
